/**
 * Adzuki
 * reminders.js
 *
 * Header "Task List" button
 */

(function Reminders($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		$(".reminders-link a").qtip({
			show: {
				event: 'click',
				solo : true
			},
			hide: {
				event: 'click'
			},
			style: {
				classes: 'qtip-bootstrap'
			},
			content: {
				text: function getReminderContent(event, api) {
					api.elements.content.html('Loading...');

					return Adzuki.Ajax.get('/Reminders/form/')
					.then(function populateQTip(content) {
						api.elements.content.html(content);
						Adzuki.Form.initAjaxForm('Reminder');
					})
					.catch(function qTipError(err) {
						api.set('content.text', err);
					});
				},
				title: {
					text  : 'Task List/Reminders',
					button: 'Close'
				},
			},
			position: {
				viewport: $('#container'),
				my      : 'top left',  // Position my top left...
				at      : 'bottom middle', // at the bottom right of...
			},
			events: {
				show: function showQtipBlanket (event, api) {
					Adzuki.Form.initAjaxForm('Reminder');

					Adzuki.QTip.fadeInOverlay();
				},
				hide: function hideQtipBlanket (event, api) {
					Adzuki.QTip.fadeOutOverlay();
				}
			}
		}).on('click', function clickReminders(e) {
			e.preventDefault();
		});
	});
}(jQuery, window.Adzuki || {}));